/** Another trip of the family: one way parting in two, as a branch parts from its trip. */
export function BranchIcon({ size = 14 }: { size?: number }) {
  return (
    <svg
      className="branch-icon"
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
      aria-hidden="true"
    >
      <circle cx="6" cy="5" r="2.2" />
      <circle cx="6" cy="19" r="2.2" />
      <circle cx="18" cy="7" r="2.2" />
      <path d="M6 7.2v9.6" />
      <path d="M18 9.2c0 4.8-12 3.4-12 7.6" />
    </svg>
  );
}
